export default __webpack_public_path__ + "static/gradient-wave-2ee37f5ab352bb11cd9801e668ada033.svg";